import { Alert, Box, Button, Dialog, DialogContent, Divider, Typography } from "@mui/material";
import { useEffect, useRef } from "react";
import { useScreenshot } from 'use-react-screenshot';
import React, { Component } from 'react';
import { AlarmOn } from "@mui/icons-material";
import Global from "../../customlib/Global";
import Api from "../../customlib/Api";
import axios from "axios";
import moment from "moment";


function CheckpointDialog(props) {

    const ref = useRef(null);
    const [image, takeScreenshot] = useScreenshot();

    const uploadImage = async (dataUrl) => {
        if(!dataUrl){
            return;
        }
        try{
            // ubah base64 data URL hasil screenshot menjadi Blob
            const blob = await (await fetch(dataUrl)).blob();
            const checkpointIds = (props.state.checkpointData ?? []).map(item => item._id);

            const formData = new FormData();
            formData.append("file", blob, "checkpoint.png");
            formData.append("jsonData", JSON.stringify({
                folder: "checkpoints",
                prefix: (Global.get()?.user?.name ?? "").replace(/\s+/g, "_").toLowerCase(),
                userId: Global.get()?.user?.id ?? "",
                username: Global.get()?.user?.name ?? "",
                appProfileId: Global.getAppProfile()?._id ?? "",
                captureAt: moment(),
                checkpointIds: checkpointIds,
                checkpointLogId: checkpointIds.length > 0 ? checkpointIds[0] : "-"
            }));

            
            // formData.append("checkPointIds", JSON.stringify(checkpointIds));

            const response = await axios.post(
                Api.checkPointUploadImage(),
                formData,
                Api.getRequestHeaderMultipart()
            );
            console.log("CP_UPLOAD_IMAGE_RESPONSE", response.data);
        }catch(err){
            console.error("CP_UPLOAD_IMAGE_ERROR", err);
        }
    };

    const captureAndUpload = async () => {
        if(!ref.current){
            return;
        }
        const dataUrl = await takeScreenshot(ref.current);
        await uploadImage(dataUrl);
    };

    useEffect(() => {
        const shouldUpload = props.state.showDialogCheckpoint && (
            (!props.state.isCheckpointMissed && props.state.checkInMessage === "") ||
            props.state.checkInMessage !== "" ||
            props.state.isCheckpointMissed
        );

        if(shouldUpload){
            // beri jeda agar konten Dialog (Portal + animasi transisi) selesai di-render
            // sebelum di-capture, jika tidak hasilnya akan kosong.
            const timer = setTimeout(() => {
                captureAndUpload();
            }, 500);
            return () => clearTimeout(timer);
        }
    }, [props.state.showDialogCheckpoint, props.state.checkInMessage, props.state.isCheckpointMissed]);

    return (
        <Box>
            {/* wkwkwkw */}
            {/* <img src={image} alt="screenshot"/> */}

            <Dialog open={props.state.showDialogCheckpoint} >
                <DialogContent ref={ref}>

                    <Box sx={{mb: "10px"}} textAlign={"center"}>
                        <Typography variant="h6" fontWeight={"bold"}>{Global.get()?.user?.name}</Typography>
                        <Box></Box>
                        <Typography variant="subtitle1" fontWeight={"normal"} fontSize={"11px"}>
                            Tab - {Global.getAppProfile()?.label}
                        </Typography>
                        <Typography variant="subtitle2" fontWeight={"normal"} fontSize={"11px"}>
                            {moment().format('DD MMM YYYY, HH:mm:ss')}
                        </Typography>
                    </Box>
                    <Divider color='error' sx={{mb: "10px"}} />
                    {
                        (!props.state.isCheckpointMissed && props.state.checkInMessage === "") && (
                            <Box>
                                <Box textAlign={"center"} fontWeight={"bold"}>
                                    <AlarmOn sx={{width: "70px", height: "70px"}} color='error' />
                                </Box>
                                <Box marginTop={"10px"} textAlign={"center"} fontWeight={"bold"}>
                                    Waktunya Check In!
                                </Box>
                                <Box>
                                    {
                                        props.state.checkpointData?.map(item => {
                                            return <Box textAlign={"center"}>{item.profileName}</Box>;
                                        })
                                    }
                                </Box>
                                <Box marginTop={"10px"} textAlign={"center"} fontWeight={"normal"}>
                                    Jangan Sampai Terlambat
                                </Box>
                                <Box textAlign={"center"} fontWeight={"normal"}>
                                    Segera Klik Tombol Check In
                                </Box>
                                <Divider color='error' sx={{mt: "10px", mb: "10px"}} />

                                {
                                    (props.state.errorMessage && props.state.errorMessage !== "") && (
                                        <Box sx={{mt: "10px", mb: "10px"}}>
                                            <Alert severity="error">Check In belum berhasil<br />{props.state.errorMessage}</Alert>
                                        </Box>
                                    ) 
                                }

                                <Box textAlign={"center"} fontWeight={"bold"}>
                                    <Button 
                                        disabled={props.state.isCheckingIn} 
                                        onClick={() => props.assignCheckPoint(true)} 
                                        fullWidth 
                                        variant='contained' 
                                        color='warning' 
                                        sx={{textTransform: "capitalize"}}>
                                    Check In
                                    </Button>
                                </Box>
                            </Box>
                        )
                    }
                    {
                        props.state.checkInMessage !== "" && (
                            <Box>
                                <Box textAlign={"center"} fontWeight={"bold"}>
                                    <AlarmOn sx={{width: "70px", height: "70px"}} color='error' />
                                </Box>
                                <Box marginTop={"10px"} textAlign={"center"}>
                                    <strong>Hasil Check Point</strong>
                                    <br />
                                    {
                                        props.state.checkInMessage?.map(item => {return item;})
                                    }
                                </Box>
                                <Divider color='error' sx={{mt: "10px", mb: "10px"}} />
                                <Box textAlign={"center"} fontWeight={"bold"}>
                                    <Button onClick={() => {props.resetCheckpoint(); props.closeCheckpoint();}} fullWidth variant='contained' color='warning'>Tutup</Button>
                                </Box>
                            </Box>
                        )
                    }

                    {
                        props.state.isCheckpointMissed && (
                            <Box>
                                <Box textAlign={"center"} fontWeight={"bold"}>
                                    <AlarmOn sx={{width: "70px", height: "70px"}} color='error' />
                                </Box>
                                <Box marginTop={"10px"} textAlign={"center"} fontWeight={"bold"}>
                                    Anda melewatkan kesempatan check in 
                                </Box>
                                <Box marginTop={"10px"} fontWeight="bold" fontSize={"30px"} textAlign={"center"}>
                                    {
                                        props.state.checkpointData?.map(item => {
                                            return (
                                                <Box marginTop={"8px"} fontWeight="bold" fontSize={"20px"} textAlign={"center"}>
                                                    {item.profileName} ke {item.index}
                                                </Box>
                                            );
                                        })
                                    }
                                </Box>
                                <Divider color='error' sx={{mt: "10px", mb: "10px"}} />
                                <Box textAlign={"center"} fontWeight={"bold"}>
                                    <Button onClick={() => {props.resetCheckpoint(); props.closeCheckpoint();}} fullWidth variant='contained' color='warning'>Tutup</Button>
                                </Box>
                            </Box>
                        )
                    }
                </DialogContent>
            </Dialog>
        </Box>
    );
}

export default CheckpointDialog;

